import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setToken, setRefreshToken } from '../services/tokenStorage';

// JWT'ni API chaqirmasdan dekod qilamiz
function decodeJwt(token) {
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return decoded;
  } catch {
    return null;
  }
}

export default function AuthCallback() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const rt = searchParams.get('rt');

    if (!token) {
      navigate('/login');
      return;
    }

    // Tokenlarni saqlash
    setToken(token);
    if (rt) setRefreshToken(decodeURIComponent(rt));

    // JWT payload'dan user ma'lumotlarini olamiz — API chaqirmiz shart emas
    const payload = decodeJwt(token);
    if (!payload) {
      navigate('/login');
      return;
    }

    // AuthContext uchun session cache
    try {
      const sessionUser = {
        id: payload.sub || payload.id,
        email: payload.email,
        isAdmin: !!payload.isAdmin,
        isDriver: !!payload.isDriver,
        isOperator: !!payload.isOperator,
        role: payload.isAdmin ? 'admin' : payload.isDriver ? 'driver' : payload.isOperator ? 'operator' : 'user',
        token,
      };
      localStorage.setItem('smartgaz_session', JSON.stringify(sessionUser));
    } catch {}

    // Role bo'yicha yo'naltirish
    if (payload.isAdmin) {
      window.location.href = '/dashboard';
    } else if (payload.isDriver) {
      window.location.href = '/driver/dashboard';
    } else if (payload.isOperator) {
      window.location.href = '/operator/dashboard';
    } else {
      window.location.href = '/main';
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0c1510]">
      <div className="flex flex-col items-center gap-4">
        <div className="h-16 w-16 bg-gradient-to-br from-[#1e9f6b] to-[#0d7a52] rounded-3xl flex items-center justify-center shadow-2xl shadow-[#1e9f6b]/40 animate-pulse">
          <span className="material-symbols-outlined text-white text-[32px]">sync</span>
        </div>
        <p className="text-slate-400 font-bold">{t('common.signingIn')}</p>
      </div>
    </div>
  );
}
